import { FC, useEffect, useState } from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';
import { Heading, Types } from '@marriott/mi-ui-library';
import { TextBlock } from '../../molecules';
import { getFormattedDateString, getQueryParams } from '../../utils';
import { useMounted } from '../../hooks';
import { PreferredPaymentHeaderData, PreferredPaymentHeaderProps } from './PreferredPaymentHeader.types';
import { StyledPreferredPaymentHeader } from './PreferredPaymentHeader.styles';

export const PreferredPaymentHeaderConfig = {
  emptyLabel: 'PreferredPaymentHeader',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/rfp/paymentheader`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const PreferredPaymentHeader: FC<{ model: PreferredPaymentHeaderProps }> = (props: any) => {
  const { heading, referenceNumber, eventName, checkInDate, checkOutDate } = props.model;

  const isMounted = useMounted();

  const [headerData, setHeaderData] = useState<PreferredPaymentHeaderData>({
    referenceNumber: '',
    eventName: '',
    checkInDate: '',
    checkOutDate: '',
  });

  useEffect(() => {
    if (isMounted) {
      const { OptyId, Event, ADate, DDate } = getQueryParams(window.location.search);
      setHeaderData({ referenceNumber: OptyId, eventName: Event, checkInDate: ADate, checkOutDate: DDate });
    }
  }, [isMounted]);

  const isLoading = Object.values(headerData).some(value => !value);

  return (
    <EditableComponent config={PreferredPaymentHeaderConfig} {...props}>
      <div className="fullbleed m-container-fullbleed alternate">
        <StyledPreferredPaymentHeader
          className="container py-5"
          data-testid="paymentheader"
          data-component-name="o-groups-paymentheader"
        >
          <Heading
            variation={Types.headingType.title}
            titleText={heading}
            element={Types.tags.h1}
            fontSize={Types.size.small}
          />
          {isLoading ? (
            <div className="row pt-4 pt-md-5">
              <div className="skeleton-loader col-12 loader"></div>
            </div>
          ) : (
            <>
              <div className="row">
                <TextBlock label={referenceNumber} value={headerData.referenceNumber} customClass="col-md-5 col-lg-4" />
                <TextBlock label={eventName} value={headerData.eventName} customClass="col-md-5 col-lg-4" />
              </div>
              <div className="row">
                <TextBlock
                  label={checkInDate}
                  value={getFormattedDateString(headerData.checkInDate, 'longDateWithDayMonthAndYear')}
                  customClass="col-md-5 col-lg-4"
                />
                <TextBlock
                  label={checkOutDate}
                  value={getFormattedDateString(headerData.checkOutDate, 'longDateWithDayMonthAndYear')}
                  customClass="col-md-5 col-lg-4"
                />
              </div>
            </>
          )}
        </StyledPreferredPaymentHeader>
      </div>
    </EditableComponent>
  );
};
